import React, { Component } from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"
import { API_URL } from "helpers/app_url"
import axios from "axios"
class ProjectBarchart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      series: [],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#6ce5e8", "#41b8d5"],
        grid: {
          borderColor: "#f1f1f1",
        },
        xaxis: {
          categories: [],
        },
      },
    };
  }
  fetchProjectBarChartData = async () => {
    const agentId = localStorage.getItem("userId");
    const builderId = this.props.builderId;
    const projectId = this.props.projectId;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Builder/GetProjectBuilderCityDashboardByAgent?agentId=${agentId}&builderId=${builderId}&projectId=${projectId}`;
  
    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
  
      if (response.data && Array.isArray(response.data)) {
        this.setState({
          series: series,
          options: {
            ...this.state.options,
            xaxis: {
              categories: categories,
            },
          },
        });
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);
      this.setState({ error: error.message });
    }
  };
  componentDidMount() {
    this.fetchProjectBarChartData()
  }
  componentDidUpdate(prevProps) {
    if (prevProps.projectId !== this.props.projectId) {
      this.fetchProjectBarChartData();
    }
  }
  componentWillUnmount() {
    this.setState({ series: [], options: {} });
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}
ProjectBarchart.propTypes = {
  builderId: PropTypes.any,
  projectId:PropTypes.any
}
export default ProjectBarchart
